/* unplugin-vue-components disabled */import { render } from "./F3DScaleARender.vue?vue&type=template&id=a35f8966&scoped=true"
import script from "./F3DScaleARender.vue?vue&type=script&lang=js"
export * from "./F3DScaleARender.vue?vue&type=script&lang=js"

import "./F3DScaleARender.vue?vue&type=style&index=0&id=a35f8966&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a35f8966"]])

export default __exports__